import React, { createContext, useState } from 'react';

type CampanhaProps = {
  campanhaState: string;
  setCampanhaState: React.Dispatch<React.SetStateAction<string>>;
};

const initialValues = {
  campanhaState: 'SuperCampeoes',

  setCampanhaState: () => {
    ('');
  }
};

const CampanhaContext = createContext<CampanhaProps>(initialValues);

const CampanhaContextProvider: React.FC = ({ children }) => {
  const [campanhaState, setCampanhaState] = useState(
    initialValues.campanhaState
  );

  return (
    <CampanhaContext.Provider
      value={{
        campanhaState,
        setCampanhaState
      }}
    >
      {children}
    </CampanhaContext.Provider>
  );
};
export { CampanhaContextProvider };
export default CampanhaContext;
